function initSlideshows(container) {
    const slideshows = container.querySelectorAll('.jsFullWidthSlideshow .slides');

    Array.prototype.forEach.call(slideshows, el => {
        imagesLoaded(el, function() {
            const slides = el.querySelectorAll('.slide');
            const slideCount = el.querySelectorAll('.slide').length;
            const slideCountEl = el.parentElement.querySelector('.jsSlideCount');
            const pinterestBtn = el.parentElement.querySelector('.pinterest-share-btn');
            const flickity = new Flickity(el, {
                pageDots: false,
                prevNextButtons: false,
                wrapAround: true
            });

            // Set the slide counter
            slideCountEl.innerHTML = '01/' + addZero(slideCount);

            const btnPrev = el.parentElement.querySelector('.jsArrowPrev');
            const btnNext = el.parentElement.querySelector('.jsArrowNext');

            btnPrev.addEventListener('click', e => {
                e.preventDefault();
                flickity.previous(true);
            });
            
            btnNext.addEventListener('click', e => {
                e.preventDefault();
                flickity.next(true);
            });

            // Update the slide counter on slide
            flickity.on('change', index => {
                slideCountEl.innerHTML = addZero(index + 1) + '/' + addZero(slideCount);

                // Set the Pinterest button URL
                const url = pinterestBtn.href;
                pinterestBtn.href = url.substring(0, url.indexOf('&media=') + 7) + slides[index].dataset.pinterestImageUrl;
            });
        });
    });
}